// src/Context/SliderContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Helper } from '../tools/Helper';
import { api_Routes } from "../api_Routes";

const SliderContext = createContext();

export const SliderProvider = ({ children }) => {
    const [sliders, setSliders] = useState([]);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const fetchSliders = async () => {
            try {
                setLoading(true);
                const path = location.pathname.substring(1) || 'home';
                const { response } = await Helper.Get({
                    url: `${api_Routes.Sliders.view}?page=${path}`,
                    hasToken: true,
                });

                if (response && response.data) {
                    setSliders(response.data);
                } else {
                    setSliders([]);
                }
            } catch (error) {
                console.error('Error fetching sliders:', error);
                setSliders([]);
            } finally {
                setLoading(false);
            }
        };

        fetchSliders();
    }, [location.pathname]);

    return (
        <SliderContext.Provider value={{ sliders, loading }}>
            {children}
        </SliderContext.Provider>
    );
};

export const useSlider = () => useContext(SliderContext);